export default "__VITE_ASSET__BJQJ2RnL__"